import React from 'react'
import {Document, Page} from 'react-pdf'
import LinearProgress from '@mui/material/LinearProgress';

import { Button } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const customBar = () => {
  return (
    <LinearProgress
    variant="indeterminate"
    sx={{
      background: 'rgba(255, 99, 71, 0.1)',
      '& .MuiLinearProgress-bar1Indeterminate': {
        backgroundColor: 'tomato',
      },
      '& .MuiLinearProgress-bar2Indeterminate': {
        backgroundColor: 'tomato',
      },
    }}
  />
  )
}

export default function PDFViewer({pdfBuffer, successCallback}) {
  // Handling Page changes
  const [currentPage, setCurrentPage] = React.useState(1)
  const numPagesRef = React.useRef()

  const formLoadSuccess = ({numPages}) => {
    numPagesRef.current = numPages;
    successCallback()
  }

  const traversePage = (direction) => {
    if (direction === 'prev') {
      if (currentPage > 1) {
        setCurrentPage(prevPage => prevPage - 1)
      }
    }

    if (direction === 'next') {
      if (currentPage < numPagesRef.current) {
        setCurrentPage(prevPage => prevPage + 1)
      }
    }
  }

  return (
    <>
      <Document file={{data: pdfBuffer.slice(0)}} onLoadSuccess = {formLoadSuccess} loading={customBar}>
        <Page pageNumber={currentPage}/>
      </Document>
      <div className="pdf-page-nav-container">
        <Button
          sx={{
            color: "tomato",
            '&:hover': {
              background: 'rgba(255, 99, 71, 0.1)'
            }
          }}
          onClick= {
            ()=> {traversePage("prev")}
          }
        >
          <NavigateBeforeIcon />
        </Button>
        <Button
          sx={{
            color: "tomato",
            '&:hover': {
              background: 'rgba(255, 99, 71, 0.1)'
            }
          }}
          onClick= {
            ()=> {traversePage("next")}
          }
        >
          <NavigateNextIcon />
        </Button>
      </div>
    </>
  )
}
